import React from 'react';
import "./contactSectionComponent.scss";
import FollowUsComponent from "./components/FollowUsComponent";
import AboutUsComponent from "./components/AboutUsComponent";
import CopyRightComponent from "./components/CopyRightComponent";

const ContactSectionComponent = () => {
    return (
        <div className="contactSectionComponent__container">
            <FollowUsComponent />
            <AboutUsComponent />
            <CopyRightComponent />
        </div>
    );
};

export default ContactSectionComponent;